import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function observeredSection() {
    const mql = window.matchMedia("(max-width: 834px)");
    const sections = [...document.querySelectorAll("[data-section]")];
    const navItems = [...document.querySelectorAll("[data-nav-item]")];

    function setCurrentClassToNav(el) {
        const navId = el.dataset.section;

        for (const item of navItems) {
            item.classList.remove("-current");
        }

        return navItems.find((item) => item.dataset.navItem === navId);
    }

    function setCurrentClassToNavState(el) {
        const navState = el.dataset.nav;

        if (navState === "dark") {
            document.body.setAttribute("data-navstate", "dark");
        } else {
            document.body.setAttribute("data-navstate", "default");
        }
    }

    for (const section of sections) {
        ScrollTrigger.create({
            trigger: section,
            start: "top 75%",
            end: "bottom 40%",
            onEnter: () => {
                section.setAttribute("data-reveal", "1");
                if (mql.matches) return;
                setCurrentClassToNav(section).classList.add("-current");
            },
            onEnterBack: () => {
                if (mql.matches) return;
                setCurrentClassToNav(section).classList.add("-current");
            },
        });
    }

    for (const section of sections) {
        ScrollTrigger.create({
            trigger: section,
            start: "top top",
            end: "bottom top",
            onEnter: () => {
                setCurrentClassToNavState(section);
            },
            onEnterBack: () => {
                setCurrentClassToNavState(section);
            },
        });
    }
}
